module.exports = __webpack_public_path__ + "img/logo-tc-black.a10cacf4.svg";